import * as t from 'io-ts';

export const formCodec = t.type({
  subject: t.string,
  description: t.union([t.string, t.undefined]),
  screenRecording: t.union([t.string, t.undefined]),
});
